import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appChoice: [],
    router: '',
    theme: false,
    clientWidth:null
  },

  getters: {
    // 参数列表state指的是state数据
    getChoice(state) {
      return state.appChoice;
    },
    getRouter(state) {
      return state.router;
    },
    getTheme(state) {
      return state.theme;
    },
    getClientWidth(state) {
      return state.clientWidth;
    },
  },
  mutations: {
    setChoice(state, name) {
      state.appChoice = name;//将传参设置给state的city
    },

    setRouter(state, router) {
      state.router = router;//将传参设置给state的city
    },

    setTheme(state, router) {
      state.theme = router
    },
    setClientWidth(state, page) {
      state.clientWidth = page; //将传参设置给state的变量,修改变量的值
    },
  },
  action: {
    // eslint-disable-next-line no-unused-vars
  },
  modules: {},
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
});
